export default __webpack_public_path__ + "static/media/pic1.5fd92293.jpg";